/* navigation */
// general styles for desktop navigation

/*
 * @prop --component-navigation-element-background-color-hover: Background color of navigation element on hover
 * @prop --component-navigation-element-color: color of navigation element
 * @prop --component-navigation-element-color-active-text: color of active navigation element
*/

// resonsive behaviour
/* stylelint-disable declaration-no-important */
ui-cms-navigation-element {
  @include reset-ul();
  @include reset-li();

  font-size: $serviceNavigation-font-size;
  line-height: 26px;

  // navigation flyout
  .position-helper {
    display: block !important;
    visibility: hidden;
  }

  li {
    @include reset-li();

    // active states
    &.active > a strong {
      color: var(--component-navigation-element-color-active-text, var(--skin-color-accent, $ui-green));
    }

    // main navigation 1st level
    &.first-level {
      color: red;

      @include reset-li();

      position: relative;

      .no-js & {
        position: static;
      }

      &.static {
        position: static;
      }

      a {
        display: inline-block;
        padding: 11px 15px;
      }

      &.hover,
      &:hover {
        > a {
          position: relative;
          background-color: var(--component-navigation-element-background-color-hover, $ui-grey-minus-2);
        }

        .no-js & {
          .flyout {
            display: block;
          }
        }
      }

      .no-js &:hover {
        > a {
          &::after {
            background-color: $ui-white;
            bottom: -1px;
            content: '';
            height: 8px;
            left: 0;
            position: absolute;
            width: 100%;
            z-index: $z-index-navigation-flyout-hover;
          }
        }
      }

      &.hover {
        > a {
          background-color: var(--component-navigation-element-background-color-hover, $ui-grey-minus-2);
        }

        .flyout {
          display: block;
          z-index: $z-index-nav-flyout;
        }
      }
    }

    font-size: $serviceNavigation-font-size;

    @include breakpoint($desktop) {
      display: inline-block;
    }

    @include breakpoint($largeMaxWidth) {
      &.overview-link a {
        strong {
          color: var(--component-navigation-element-color-active-text, var(--skin-color-accent, $ui-green));
        }
      }
    }

    @include breakpoint($largeMaxWidth) {
      strong:first-child {
        color: var(--component-navigation-element-color, var(--skin-color-primary, $ui-blue));
        display: block;
      }
    }

    strong {
      font-weight: $font-weight-bold;
    }

    a:not(.btn) {
      color: var(--component-navigation-element-color, var(--skin-color-primary, $ui-blue));
      cursor: pointer;
      text-decoration: none;
    }

    &.active {
      @include breakpoint($desktop) {
        a > strong {
          position: relative;
        }
      }
    }

    .header--stiftung & {
      & > li {
        font-size: 15px;

        @include breakpoint($xlarge) {
          font-size: $serviceNavigation-font-size;
        }

        & > a,
        & > a strong {
          transition: color 0.1s;
        }

        &.active > a strong::after {
          transition: background-color 0.1s;
        }

        &.hover > a,
        &.hover > a strong {
          box-shadow: none;
          color: $ui-blue-minus-1;
        }

        &.active.hover > a strong::after {
          background-color: $ui-blue-minus-1;
        }
      }
    }
  }

  .menuItemMeta {
    font-size: $metadata-font-size;
    line-height: $metadata-line-height;
  }

  .flyout {
    display: none;
    height: 10px;
    left: 0;
    position: absolute;
    transform: translateX(1px);
    z-index: $z-index-navigation-flyout;

    .menu-wrapper {
      @include clearfix();
      @include reset-ul();

      background-color: $ui-white;
      box-shadow: 0 1px 3px 0 rgba($ui-grey-plus-4, 0.75);
      margin: 0;

      > li {
        display: block;
        float: left;
        margin: 0 18px;
        overflow: hidden;
        padding-bottom: 24px;
        padding-top: 25px;
        width: calc(25% - 36px); // 36px are margins
        box-sizing: content-box;

        a {
          color: $ui-dark;
          display: block;
          font-size: $metadata-font-size;
          line-height: $metadata-line-height;
          padding: 9px 15px;

          &:hover {
            background-color: var(--component-navigation-element-background-color-hover, $ui-grey-minus-2);
          }

          strong {
            color: var(--component-navigation-element-color, var(--skin-color-primary, $ui-blue));
            font-size: $copy-font-size;
            line-height: $copy-line-height;

            &:first-child {
              display: block;
            }
          }

          strong::after {
            content: none;
          }

          strong + span {
            display: block;
            margin-top: 8px;
          }
        }

        &.hub-navigation {
          margin: 0;
          position: relative;
          width: 100%;

          &::before {
            background-color: $ui-grey;
            content: '';
            height: 1px;
            position: absolute;
            top: 0;
            width: 96.875%;
          }
        }
      }

      .hub-navigation {
        padding: 24px 0 16px;

        &__headline {
          color: $ui-dark;
          font-size: $h3-font-size;
          line-height: $h3-line-height;
          padding-left: 32px;
        }

        &__headline + ul {
          margin-top: 14px;
        }

        .hub-link-wrapper {
          h2 {
            color: var(--component-navigation-element-color, var(--skin-color-primary, $ui-blue));
            font-size: $copy-font-size;
            line-height: $copy-line-height;
            margin: 0;
            padding: 0;
          }

          p {
            font-size: $metadata-font-size;
            line-height: $metadata-line-height;
            margin-top: 8px;
          }
        }

        li {
          display: block;
          float: left;
          margin: 0 18px;
          width: calc(25% - 36px);

          &:nth-of-type(5n) {
            clear: both;
          }
        }
      }

      ul {
        @include reset-ul();

        li {
          display: block;

          a {
            display: block;
            padding: 8px 15px 9px;

            strong {
              color: var(--component-navigation-element-color, var(--skin-color-primary, $ui-blue));
              font-size: 14px;
            }
          }

          &:first-child {
            margin-top: 0;
          }
        }
      }
    }

    &.align-left {
      left: 0;
    }

    &.align-right {
      left: auto;
      right: 0;
    }

    &.multilines {
      .menu-wrapper > li {
        border-bottom: 1px solid $ui-grey;
      }

      &.rows-2 .menu-wrapper > li {
        &:nth-of-type(5),
        &:nth-of-type(6),
        &:nth-of-type(7),
        &:nth-of-type(8) {
          border-bottom: none;
        }
      }

      &.rows-3 .menu-wrapper > li {
        &:nth-of-type(9),
        &:nth-of-type(10),
        &:nth-of-type(11),
        &:nth-of-type(12) {
          border-bottom: none;
        }
      }
    }

    .menu-wrapper > li:nth-child(n + 5) {
      padding-top: 14px;
    }
  }
}
